import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=70ffe01a&scoped=true"
import script from "./DetailForm.vue?vue&type=script&lang=js"
export * from "./DetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ffe01a",
  null
  
)

export default component.exports